import { Star, Quote } from 'lucide-react'
import { useLanguage } from '@/i18n/LanguageContext'
import { SectionHeading } from '@/components/ui/SectionHeading'
import { GlassCard } from '@/components/ui/GlassCard'
import { TESTIMONIALS } from '@/lib/testimonials'

/** #recenzije — Phase 4. Real client reviews only (master prompt §2.6/§5.4), no fake ratings beyond the site's own 5-star display. */
export function TestimonialsSection() {
  const { t, lang } = useLanguage()

  return (
    <section id="recenzije" className="px-6 py-section-gap md:px-margin-desktop">
      <div className="mx-auto flex max-w-container flex-col gap-10">
        <SectionHeading title={t('reviews-title')} subtitle={t('reviews-sub')} />

        {/* Mobile: horizontal drag/swipe scroll-snap row (no extra library needed —
            native overflow-x-auto + scroll-snap handles touch drag). Desktop:
            back to the original 2-col grid, scrolling disabled. */}
        <div className="-mx-6 flex snap-x snap-mandatory gap-4 overflow-x-auto px-6 pb-2 md:mx-0 md:grid md:snap-none md:grid-cols-2 md:gap-6 md:overflow-visible md:px-0 md:pb-0">
          {TESTIMONIALS.map((testimonial) => (
            <GlassCard
              key={testimonial.id}
              className="flex w-[85vw] shrink-0 snap-center flex-col gap-5 p-6 sm:w-[60vw] md:w-auto md:shrink md:p-7"
            >
              <div className="flex items-center justify-between">
                <div className="flex gap-0.5 text-accent-amber-light" aria-hidden="true">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star key={i} size={16} fill="currentColor" strokeWidth={0} />
                  ))}
                </div>
                <Quote size={22} className="text-foreground-muted/30" />
              </div>

              <p className="text-base leading-relaxed text-foreground-subtle">
                {lang === 'en' ? testimonial.quoteEn : testimonial.quote}
              </p>

              <div className="mt-auto flex items-center gap-3">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-fire/15 font-serif text-base font-semibold text-accent-fire">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground">{testimonial.name}</div>
                  <div className="text-xs text-foreground-muted">
                    {lang === 'en' ? testimonial.roleEn : testimonial.role}
                  </div>
                </div>
              </div>
            </GlassCard>
          ))}
        </div>
      </div>
    </section>
  )
}
